import { Outlet, useMatches } from 'react-router-dom';
import bsLogo from '@/shared/assets/bs-logo.png';
import { useEffect } from 'react';

interface RouteHandle {
  subtitle?: string;
}

const WorkflowLayout = () => {
  const matches = useMatches();
  const activeRouteWithTitle = matches.find(
    (match) => (match.handle as RouteHandle)?.subtitle
  );

  useEffect(() => {
      document.body.classList.add('nh-page');
      return () => {
        document.body.classList.remove('nh-page');
      };
    }, []);
  const pageTitle = (activeRouteWithTitle?.handle as RouteHandle)?.subtitle || '';
  return (
    <div className="min-h-screen bg-white sm:bg-[#4A4A4A] flex items-center justify-center sm:p-4 font-sans">
      <div className="bg-white w-full sm:max-w-[400px] min-h-screen sm:min-h-[800px] flex flex-col relative sm:shadow-2xl overflow-hidden rounded-none sm:rounded-md">

        {/* Header Block */}
        <div className="bg-[#011E37] h-14 w-full shrink-0" />
        <div className="flex flex-col items-center mt-6 mb-6 px-6 text-center">
          <div className="flex flex-col items-center space-x-3 relative mb-2">
            <img src={bsLogo} alt="Bluestone" className="h-11 w-41" />
            <span className="text-[#011E37] text-sm tracking-widest absolute top-[27px] left-[43px] mt-1">
              {pageTitle}
            </span>
          </div>
        </div>

        {/* Dynamic Page Content Wrapper */}
        <div className="flex-1 flex flex-col w-full px-3">
          <Outlet />
        </div>

      </div>
    </div>
  );
};

export default WorkflowLayout;